import React from "react";
import Layout from "@/components/Layout";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import QuizStart from "@/components/QuizStart";
import BlueprintCoursePreview from "@/components/BlueprintCoursePreview";
import { useNavigate } from "react-router-dom";

const Index: React.FC = () => {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    // Log page render to help with debugging
    console.log("Index page rendered");
    
    // Add a more comprehensive check for duplicate elements
    setTimeout(() => {
      // Check for progress cards by component attribute
      const cards = document.querySelectorAll('[data-component="hero-progress-card"]');
      const count = cards.length;
      
      console.log(`Found ${count} progress cards on page`);
      
      // Add the guard-rail assertion as suggested
      if (count !== 1) {
        console.error(`❌ Expected 1 hero-progress-card, found ${count}`);
        
        if (count > 1) {
          console.warn("Multiple AI governance cards detected - check components for duplicates");
          cards.forEach((card, index) => {
            console.log(`Card ${index + 1} ID:`, card.id || "No ID");
            console.log(`Card ${index + 1} parent:`, card.parentElement?.tagName || "Unknown parent");
            console.log(`Card ${index + 1} parent class:`, card.parentElement?.className || "No class");
            console.log(`Card ${index + 1} HTML:`, card.outerHTML.substring(0, 150) + "...");
          });
        }
      } else {
        console.log("✅ Correct number of hero-progress-cards found");
      }
      
      // Check for any elements with "AI Governance Readiness" text
      const readinessTextElements = Array.from(document.querySelectorAll('*')).filter(el => 
        el.textContent && el.textContent.includes("AI Governance Readiness")
      );
      
      console.log(`Found ${readinessTextElements.length} elements containing "AI Governance Readiness" text`);
      
      if (readinessTextElements.length > 1) {
        console.error(`❌ Expected 1 "AI Governance Readiness" text instance, found ${readinessTextElements.length}`);
        
        readinessTextElements.forEach((el, index) => {
          const elementInfo = {
            tagName: el.tagName,
            className: (el as HTMLElement).className || "No class",
            id: (el as HTMLElement).id || "No ID",
            parentTagName: el.parentElement ? el.parentElement.tagName : "No parent",
            parentId: el.parentElement ? el.parentElement.id || "No parent ID" : "No parent",
            parentClass: el.parentElement ? el.parentElement.className || "No parent class" : "No parent",
            textContent: el.textContent?.substring(0, 50) + "...",
            componentPath: (el as HTMLElement).getAttribute('data-component-path') || "No path"
          };
          console.log(`Text instance ${index + 1}:`, elementInfo);
          console.log(`Full element ${index + 1}:`, el);
          
          // Log parent hierarchy to help find where this element comes from
          let parent = el.parentElement;
          let hierarchy = [];
          let depth = 0;
          const maxDepth = 5;
          
          while (parent && depth < maxDepth) {
            hierarchy.push({
              tagName: parent.tagName,
              id: parent.id || "No ID",
              className: parent.className || "No class",
              dataAttrs: Array.from(parent.attributes)
                .filter(attr => attr.name.startsWith('data-'))
                .map(attr => `${attr.name}="${attr.value}"`)
                .join(', ') || "No data attributes"
            });
            parent = parent.parentElement;
            depth++;
          }
          
          console.log(`Parent hierarchy for element ${index + 1}:`, hierarchy);
        });
      } else {
        console.log("✅ Correct number of AI Governance Readiness text instances found");
      }
    }, 500);
  }, []);

  // Add the enhanced runtime assertion with colored output
  React.useEffect(() => {
    setTimeout(() => {
      const count = document.querySelectorAll(
        '[data-component="hero-progress-card"]'
      ).length;

      if (count !== 1) {
        console.error(
          `%c❌  Expected 1 hero-progress-card, found ${count}`,
          'color:red; font-weight:bold; font-size:14px;'
        );
      } else {
        console.log(
          '%c✅  Exactly one hero-progress-card present',
          'color:green; font-weight:bold;'
        );
      }
    }, 700); // Slight delay to ensure it runs after the first check
  }, []);

  return (
    <Layout>
      <Hero />
      <BlueprintCoursePreview />
      <Features />
      <QuizStart onStart={() => navigate('/quiz')} />
    </Layout>
  );
};

export default Index;
